import { cx } from "utils";


export type PlanTab = "Core" | "Growth";

interface CoreGrowthSegmentedControlProps {
  activeTab: PlanTab;
  onChange: (tab: PlanTab) => void;
}

export default function CoreGrowthSegmentedControl({
  activeTab,
  onChange,
}: CoreGrowthSegmentedControlProps) {
  return (
    <div className="inline-flex items-center" role="tablist" aria-label="Plan category">
      <button
        type="button"
        role="tab"
        aria-selected={activeTab === "Core"}
        onClick={() => onChange("Core")}
        className={cx(
          "h-10 px-8 text-base leading-6 rounded-l border border-neutral-900",
          activeTab === "Core"
            ? "bg-primary-600 text-white border-primary-600"
            : "bg-white text-neutral-900"
        )}
      >
        Core
      </button>
      <button
        type="button"
        role="tab"
        aria-selected={activeTab === "Growth"}
        onClick={() => onChange("Growth")}
        className={cx(
          "h-10 px-8 text-base leading-6 rounded-r border border-l-0 border-neutral-900",
          activeTab === "Growth"
            ? "bg-primary-600 text-white border-primary-600"
            : "bg-white text-neutral-900"
        )}
      >
        Growth
      </button>
    </div>
  );
}
